import React from 'react';
import { CustomDropdownStyle } from '../styledComponents/StyledCustomDropdown';
import BottomArrow from '../svgIcons/BottomArrow';
import { ArrayLengthCheck, randomKey } from '../../../utils/helper';
import DropdownItem from 'react-bootstrap/DropdownItem';
import { ErrorMessage, FastField } from 'formik';
import { formErrorMessage } from './FormErrorMessage';

const FormikDropDown = ({ name, options, disabled = false, ...props }) => {
  return (
    <FastField name={name}>
      {({ field: { value }, form: { setFieldValue } }) => (
        <>
          <CustomDropdownStyle
            toggleClassName={`table-dropdown ms-0 table-text new-font ${
              disabled ? 'disabled' : ''
            }`}
            className={`custom-drop-down table-dropdown-custom drop-down new-font ${
              disabled ? 'disabled' : ''
            }`}
            dropdownToggle={
              <span
                className={`flex-center p-2 w-100 justify-content-between new-font ${
                  disabled ? 'disabled' : ''
                }`}
              >
                <h6 className="me-1 me-lg-2 mb-0 trucate">
                  {options?.find((o) => o?.value === value)?.label || 'Select'}
                </h6>
                <BottomArrow
                  className="ms-auto"
                  rotate="down"
                  width="24px"
                  height="24px"
                />
              </span>
            }
            dropdownMenu={
              <>
                {ArrayLengthCheck(options).map((list, i) => {
                  return (
                    <DropdownItem
                      key={`${randomKey()}-${i}-${list?.label}`}
                      onClick={() => {
                        setFieldValue(name, list?.value);
                      }}
                    >
                      {list?.label}
                    </DropdownItem>
                  );
                })}
              </>
            }
            value={value || ''}
            {...props}
          />
          <ErrorMessage name="bankName" render={formErrorMessage} />
        </>
      )}
    </FastField>
  );
};

export default FormikDropDown;
